export enum LocalStorageKey {
  /** @knipignore Not sure why this is marked as unused */
  DRAFT_EDITOR_PANELS = "draftEditorPanels",
}
